import { PAYMENTS_API_URL } from 'data/constants';

export async function notifyAboutClientPayment(depositId: string) {
  const result = await fetch(
    `${PAYMENTS_API_URL}/public/payments/${depositId}/notify`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to set payment name: ${responseBody}`);
  }
}
